import { Phone, Search } from "lucide-react";
import React, { JSX } from "react";

interface PhoneInputProps {
  phone: string;
  setPhone: (value: string) => void;
  onSearch: () => void;
  onReset: () => void;
}

const PhoneInput = (props: PhoneInputProps): JSX.Element => {
  return (
    <div className="space-y-4 mb-8">
      {/* Step heading with icon */}
      <div className="flex items-center gap-2">
        <Phone className="h-6 w-6 text-primary" />
        <h3 className="text-xl font-bold text-foreground">Paso 1.</h3>
      </div>

      {/* Instruction text */}
      <p className="text-muted-foreground">Busca tu número de teléfono:</p>

      {/* Input group with search button */}
      <div className="flex gap-3">
        <div className="flex-1 flex items-center bg-white border border-input rounded-lg px-4 py-3 focus-within:ring-2 focus-within:ring-ring">
          <Phone className="h-5 w-5 text-muted-foreground mr-3" />
          <input
            type="text"
            placeholder="##########"
            maxLength={10}
            value={props.phone}
            onChange={(event) => props.setPhone(event.target.value)}
            className="flex-1 outline-none text-foreground bg-transparent"
          />
        </div>
        <button
          onClick={() => props.onSearch()}
          className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg px-6 py-3 transition-colors shadow-medium"
        >
          <Search className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default PhoneInput;
